import { last, isEmpty } from "lodash";

export const getSlug = (pathname: string) => {
  if (isEmpty(pathname)) return null;
  return last(pathname.split("/"));
};
